import { useBreadcrumbsContext } from 'app/context';
import { useEffect } from 'react';
import { Cnab444PageContent } from './components';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from 'modules/auth/context';
import { EAccountPermissions } from 'modules/auth/context/permify/permify.interfaces';
import CessionIcon from 'app/components/Icons/CessionIcon';
import { useTheme } from '@mui/material';

const Cnab444Page = () => {
  const theme = useTheme();
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { userInfo } = useAuthContext();
  const navigate = useNavigate();
  const { id: fundingId } = useParams();

  useEffect(() => {
    if (!userInfo?.permissions?.includes(EAccountPermissions.CNAB)) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    setItems(
      [
        // HK: Ajustar quando Cessão tiver uma page
        { to: `/cession/${fundingId}/cnab444`, label: 'Cessão' },
        { to: `/cession/${fundingId}/cnab444`, label: 'CNAB 444' },
      ],
      <CessionIcon color={theme.palette.text.secondary} />,
    );

    return () => resetBreadcrumbs();
  }, []);

  if (!userInfo?.permissions?.includes(EAccountPermissions.CNAB)) return null;

  return <Cnab444PageContent />;
};

export default Cnab444Page;
